export function IconArrowRight({ size = 18, className = "", ...props }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" className={className} style={{ flexShrink: 0 }} {...props}>
      <line x1="5" y1="12" x2="19" y2="12" />
      <polyline points="12 5 19 12 12 19" />
    </svg>
  );
}

export function IconChevronDown({ className = "w-3 h-3", ...props }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className={className} {...props}>
      <polyline points="6 9 12 15 18 9" />
    </svg>
  );
}

export function IconChevronLeft({ className = "w-4 h-4", ...props }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} {...props}>
      <polyline points="15 18 9 12 15 6" />
    </svg>
  );
}

/* ================= 6 STEPS ICONS ================= */

// 1. UNDERSTAND: Book
export function IconStepUnderstand({ size = 44, color = "#C59F42" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" stroke={color} strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M6 12 C 14 10, 20 12, 24 15 C 28 12, 34 10, 42 12 V 38 C 34 36, 28 38, 24 41 C 20 38, 14 36, 6 38 Z" fill="rgba(197,159,66,0.08)" />
      <line x1="24" y1="15" x2="24" y2="41" />
      <path d="M11 18 H 19" strokeWidth="1.8" />
      <path d="M11 24 H 19" strokeWidth="1.8" />
      <path d="M29 18 H 37" strokeWidth="1.8" />
      <path d="M29 24 H 37" strokeWidth="1.8" />
    </svg>
  );
}

// 2. BECOME AWARE: Head with Brain / Radiating light
export function IconStepAware({ size = 44, color = "#C59F42" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" stroke={color} strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14 40 V 37 C 14 33, 16 32, 20 30 C 18 28, 17 25, 17 22 C 17 14, 31 14, 31 22 C 31 25, 30 28, 28 30 C 32 32, 34 33, 34 37 V 40" />
      <circle cx="24" cy="21" r="5" strokeWidth="1.8" strokeDasharray="2 2" fill="rgba(197,159,66,0.15)" />
      <line x1="24" y1="8" x2="24" y2="12" strokeWidth="2" />
      <line x1="15" y1="12" x2="18" y2="15" strokeWidth="1.8" />
      <line x1="33" y1="12" x2="30" y2="15" strokeWidth="1.8" />
      <line x1="12" y1="21" x2="16" y2="21" strokeWidth="1.8" />
      <line x1="36" y1="21" x2="32" y2="21" strokeWidth="1.8" />
    </svg>
  );
}

// 3. TRANSFORM: Cyclic arrows (Habit Loop)
export function IconStepTransform({ size = 44, color = "#C59F42" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" stroke={color} strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M24 10 A 14 14 0 0 1 37 20" />
      <polyline points="32 20 37 20 37 15" fill={color} />
      <path d="M37 28 A 14 14 0 0 1 24 38" />
      <polyline points="29 38 24 38 24 33" fill={color} />
      <path d="M17 34 A 14 14 0 0 1 11 24 A 14 14 0 0 1 20 11" />
      <polyline points="20 16 20 11 15 11" fill={color} />
      <circle cx="24" cy="24" r="3" fill={color} stroke="none" />
    </svg>
  );
}

// 4. COMPLETE: Blooming Lotus Flower
export function IconStepComplete({ size = 44, color = "#C59F42" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" stroke={color} strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
      {/* Central petal */}
      <path d="M24 12 C 20 20, 20 28, 24 36 C 28 28, 28 20, 24 12 Z" fill="rgba(197,159,66,0.12)" />
      {/* Left petal */}
      <path d="M22 17 C 14 20, 10 27, 13 34 C 18 36, 21 34, 23 33" />
      {/* Right petal */}
      <path d="M26 17 C 34 20, 38 27, 35 34 C 30 36, 27 34, 25 33" />
      {/* Base water line */}
      <path d="M14 38 C 20 37, 28 37, 34 38" strokeWidth="1.8" />
    </svg>
  );
}

// 5. CREATE: Sprout / Seedling in nurturing hands
export function IconStepCreate({ size = 44, color = "#C59F42" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" stroke={color} strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
      {/* Stem */}
      <path d="M24 38 V 22" strokeWidth="2.4" />
      {/* Left leaf */}
      <path d="M24 26 C 18 26, 14 21, 15 15 C 21 15, 24 20, 24 26 Z" fill="rgba(197,159,66,0.14)" />
      {/* Right leaf */}
      <path d="M24 22 C 30 22, 34 17, 33 11 C 27 11, 24 16, 24 22 Z" fill="rgba(197,159,66,0.14)" />
      {/* Earth / soil curve */}
      <path d="M12 39 C 18 36, 30 36, 36 39" strokeWidth="2" />
    </svg>
  );
}

// 6. LIVE: Victorious Person Raising Arms
export function IconStepLive({ size = 44, color = "#C59F42" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" stroke={color} strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
      {/* Head */}
      <circle cx="24" cy="13" r="4.5" fill={color} stroke="none" />
      {/* Raised Arms */}
      <path d="M11 16 L 24 24 L 37 16" strokeWidth="2.6" />
      {/* Body / Torso */}
      <line x1="24" y1="24" x2="24" y2="34" strokeWidth="2.6" />
      {/* Legs */}
      <path d="M17 41 L 24 34 L 31 41" strokeWidth="2.6" />
    </svg>
  );
}

/* ================= TRANSFORMATION JOURNEY (NAVY BAR) ICONS ================= */

export function IconJourneyUnderstand({ size = 26, color = "#FFFFFF" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
      <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
    </svg>
  );
}

export function IconJourneyExperience({ size = 26, color = "#FFFFFF" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
  );
}

export function IconJourneyApply({ size = 26, color = "#FFFFFF" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="3" />
      <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" />
    </svg>
  );
}

export function IconJourneyTransform({ size = 26, color = "#FFFFFF" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21.5 2v6h-6" />
      <path d="M21.34 15.57a10 10 0 1 1-.57-8.38l5.67-5.67" />
    </svg>
  );
}

export function IconJourneyLive({ size = 26, color = "#FFFFFF" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="5" />
      <line x1="12" y1="1" x2="12" y2="3" />
      <line x1="12" y1="21" x2="12" y2="23" />
      <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
      <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
      <line x1="1" y1="12" x2="3" y2="12" />
      <line x1="21" y1="12" x2="23" y2="12" />
      <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
      <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
    </svg>
  );
}

/* ================= CONTACT & SOCIAL ICONS ================= */

export function IconPhoneContact({ size = 20, className = "" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
    </svg>
  );
}

export function IconWhatsAppContact({ size = 20, className = "" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
      <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
    </svg>
  );
}

export function IconEmailContact({ size = 20, className = "" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
      <polyline points="22,6 12,13 2,6" />
    </svg>
  );
}

export function IconFacebookSocial({ size = 18, color = "currentColor" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
      <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
    </svg>
  );
}

export function IconYouTubeSocial({ size = 18, color = "currentColor" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
      <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.5 12 3.5 12 3.5s-7.505 0-9.377.55a3.016 3.016 0 0 0-2.122 2.136C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.55 9.376.55 9.376.55s7.505 0 9.377-.55a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
    </svg>
  );
}

export function IconLinkedInSocial({ size = 18, color = "currentColor" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
      <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
    </svg>
  );
}

export function IconInstagramSocial({ size = 18, color = "currentColor" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
      <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
      <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
    </svg>
  );
}
